/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { atom } from 'jotai';
import { activeSanctioningBodyIdAtom } from 'jotai/sanctioningBody';
import { RaceProgressionData, SanctioningBodyEnum } from 'models/viewModels';
import { raceProgressionService } from 'services/stream/RSocket';
import { defaultRaceProgressionValue } from './default';

let listenerId: string;

const currentRaceProgressionAtom = atom<RaceProgressionData>(defaultRaceProgressionValue);

const initRaceProgressionAtom = atom<null, [], () => void>(null, (get, set) => {
  const sanctioningBody = get(activeSanctioningBodyIdAtom) ?? SanctioningBodyEnum.UNKNOWN;
  listenerId = raceProgressionService.get(sanctioningBody)!.addListener(
    async (raceProgressionData) => {
      set(currentRaceProgressionAtom, raceProgressionData);
    },
    async () => {
      set(currentRaceProgressionAtom, defaultRaceProgressionValue);
    }
  );
  return () => {
    raceProgressionService.get(sanctioningBody)?.removeListener(listenerId);
  };
});

initRaceProgressionAtom.onMount = (init) => {
  init();
};

export const raceProgressionAtom = atom<RaceProgressionData>((get) => {
  get(initRaceProgressionAtom);
  return get(currentRaceProgressionAtom);
});
